import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import { MessageHelpLink } from "../../CreateTemplateModal/components/ProjectTemplateCreateSelectTypeModal.styles";
import { OpenIcon } from "@adsk/alloy-react-icon";
export var MessageHelpLinkStyled = styled(MessageHelpLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
export var OpenIconLink = styled(OpenIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 4px;\n"], ["\n  margin-left: 4px;\n"])));
var templateObject_1, templateObject_2;
